<template>
  <el-dialog
    title="Edit Attachment"
    visible
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      :model="attachment"
    >
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Is Shared"
            prop="file.is_shared"
          >
            <el-switch v-model="attachment.file.is_shared" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Is Public"
            prop="file.is_public"
          >
            <el-switch v-model="attachment.file.is_public" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button
        @click.native="$emit('update:isShow', false)"
      >
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isLoading"
        @click.native="save"
      >
        Save
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    attachment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isFullscreen: false,
      isLoading: false
    }
  },
  methods: {
    save () {
      this.isLoading = true
      this.attachment.file.update()
        .then(() => { this.$message.success('Successfully Saved') })
        .finally(() => {
          this.isLoading = false
          this.$emit('reload')
          this.$emit('update:isShow', false)
        })
    }
  }
}
</script>

<style>

</style>
